<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                    
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'المستخدمين'" :to="{name: 'teachers'}">بيانات المعلمين</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i> 
                                        إدارة المعلمين
                                        </h4>
                                    </div>  
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item"><create-button  v-if="hasPermissions('teachers_create')" :routeName="'teachers.create'"></create-button></li>
                                        <li class="list-inline-item">
                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1
" v-if="searchingMode == 0" @click="searchingMode = 1"> <span>فلاتر البحث</span></button>
                                          <button class="btn btn-danger search-btn-wg mb-2 my-2 " v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>
                                      </ul>
                                                                    
                                      </div>         
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-12">
                                        <label for="">الاسم</label>
                                        <v-select v-model="data.searching.name" :options="options" @search="onSearch" />
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.searching.stage_id" @select="getGroups" :multiple="false" />
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">الصف الدراسى</label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" :multiple="false" />
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">البريد الإلكتروني</label>
                                          <input type="text" v-model="data.searching.email" class="form-control" placeholder="البريد الإلكتروني">
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">رقم الجوال</label>
                                          <input type="text" v-model="data.searching.mobile" class="form-control" placeholder="رقم الجوال">
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">رقم الواتس آب</label>
                                          <input type="text" v-model="data.searching.whatsapp" class="form-control" placeholder="رقم الوتس آب">
                                        </div>
                                        <div class="col-md-6 mt-2">
                                        <label for="">نوع المعلم</label>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <input type="radio" value="" v-model="data.searching.isSupervisor"> الكل
                                            </div>
                                            <div class="col-md-4">
                                              <input type="radio" value="1" v-model="data.searching.isSupervisor"> المشرفين التربوين
                                            </div>
                                            <div class="col-md-4">
                                              <input type="radio" value="0" v-model="data.searching.isSupervisor"> المعلمين
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-3 mt-5">
                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>
                                          <!-- <input type="submit" name="time" class=" btn btn-button-7 search-btn-wg btn-block" value="بــــحــث"> -->
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                   <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                        <table class="table table-bordered mb-4">
                                          <thead>
                                              <tr>
                                                <th>
                                                    <a href="#" @click.prevent="resortData();">
                                                      <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                      <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                    </a>
                                                  </th>
                                                  <th @click="resortData();">الاسم</th>
                                                  <th @click="resortData();">المرحلة الدراسية</th>
                                                  <th @click="resortData();">الصف الدراسي</th>
                                                  <th @click="resortData();">الحلقة / الحلقات</th>
                                                  <th @click="resortData();">البريد الإلكتروني</th>
                                                  <th @click="resortData();">رقم الجوال</th>
                                                  <th @click="resortData();">رقم الوتس آب</th>
                                                  <th class="align-center">#</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-for="(item, index) in data.data" :key="index">
                                                  <td>{{index+1}}</td>
                                                  <td>{{item.name}}</td>
                                                  <td>{{ item.stage ? item.stage.name : '---' }}</td>
                                                  <td>{{ item.group ? item.group.name : '---' }}</td>
                                                  <td>
                                                    <div v-if="item.lessons" v-for="(itLess, i) in item.lessons" :key="i">{{itLess.name}}</div>
                                                  </td>
                                                  <td>{{item.email}}</td>
                                                  <td>{{item.mobile}}</td>
                                                  <td>{{item.whatsapp}}</td>
                                                  <td class="text-center">
                                                      
                                                      <div class="dropdown custom-dropdown">
                                                          <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                              <i class="flaticon-dot-three fs-17"></i>
                                                          </a>

                                                          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                              <a href="#" class="dropdown-item" @click.prevent="print(item)">طباعة</a>
                                                              <edit-button v-if="hasPermissions('teachers_edit')" :routing="{name: 'teachers.edit', params: {id: item.id}}"></edit-button>
                                                              <delete-button v-if="hasPermissions('teachers_delete')" :deleteUrl="'/teachers/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                          </div>
                                                      </div>

                                                  </td>
                                              </tr>
                                          </tbody>
                                          <tfoot>
                                              <tr>
                                                  <th>
                                                    <a href="#" @click.prevent="resortData();">
                                                      <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                      <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                    </a>
                                                  </th>
                                                  <th @click="resortData();">الاسم</th>
                                                  <th @click="resortData();">المرحلة الدراسية</th>
                                                  <th @click="resortData();">الصف الدراسي</th>
                                                  <th @click="resortData();">الحلقة / الحلقات</th>
                                                  <th @click="resortData();">البريد الإلكتروني</th>
                                                  <th @click="resortData();">رقم الجوال</th>
                                                  <th @click="resortData();">رقم الوتس آب</th>
                                                  <th class="align-center">#</th>
                                              </tr>
                                          </tfoot>
                                          
                                      </table>
                                    </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
              <div class="row" style="display: none;" id="printMe">
                <div class="col-md-12">
                   <table class="table table-bordered">
                <tbody>
                  <tr class="text-center">
                    <th colspan="4">
                      استمارة بيانات معلم<br>
                      (السيرة الذاتية)
                    </th>
                  </tr>
                </tbody>
                <tbody>
                  <tr class="text-center">
                    <td colspan="4" style="color: white;background: black">
                      البيانات الشخصية
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">الاسم</td>
                    <td colspan="2">{{printData.name}}</td>
                  </tr>
                  <tr>
                    <td>تاريخ الميلاد</td>
                    <td>{{printData.birth_date}}</td>
                    <td>مكان الميلاد</td>
                    <td>{{printData.birth_place}}</td>
                  </tr>
                  <tr>
                    <td>الجنسية</td>
                    <td>{{printData.nationality}}</td>
                    <td>الحالة الاجتماعية</td>
                    <td>{{printData.marital_status}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">نوع العمل</td>
                    <td colspan="2">
                      {{ printData.work_type + ' ' }} <span v-if="printData.work_type == 'أخرى'">{{printData.work_type_txt}}</span>
                    </td>
                  </tr>

                  <tr class="text-center">
                    <td colspan="4">
                      معلومات الاتصال
                    </td>
                  </tr>
                  <tr>
                    <td>عنوان المنزل</td>
                    <td>{{printData.address}}</td>
                    <td>الحى</td>
                    <td>{{printData.neighborhood}}</td>
                  </tr>
                  <tr>
                    <td>رقم الجوال</td>
                    <td>{{printData.mobile}}</td>
                    <td>رقم الواتس آب</td>
                    <td>{{printData.whatsapp}}</td>
                  </tr>
                  <tr>
                    <td>هاتف المنزل</td>
                    <td>{{printData.phone}}</td>
                    <td>البريد الإلكتروني</td>
                    <td>{{printData.email}}</td>
                  </tr>
                  <tr class="text-center">
                    <td colspan="4">معلومات الهوية</td>
                  </tr>
                  <tr>
                    <td>رقم الهوية</td>
                    <td>{{printData.id_number}}</td>
                    <td>مصدرها</td>
                    <td>{{printData.id_place}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">نوع الهوية</td>
                    <td colspan="2">{{printData.id_type + ' '}} <span v-if="printData.id_type == 'أخرى'">{{printData.id_type_txt}}</span></td>
                  </tr>
                  <tr>
                    <td>تاريخها</td>
                    <td>{{printData.id_date}}</td>
                    <td>تاريخ الانتهاء</td>
                    <td>{{printData.id_expire_date}}</td>
                  </tr>
                  
                  <tr class="text-center">
                    <td colspan="4">معلومات العمل</td>
                  </tr>
                  <tr>
                    <td>العمل الرسمى</td>
                    <td>{{printData.work}}</td>
                    <td>العنوان</td>
                    <td>{{printData.work_address}}</td>
                  </tr>
                  <tr>
                    <td>مكان العمل</td>
                    <td>{{printData.work_place}}</td>
                    <td>الهاتف</td>
                    <td>{{printData.work_phone}}</td>
                  </tr>

                  <tr class="text-center">
                    <td colspan="4">المؤهل العلمى </td>
                  </tr>
                  <tr>
                    <td colspan="2">الاجازة القراءنية</td>
                    <td colspan="2">
                      <ul v-if="printData.quaran.length">
                        <li v-for="(v,k) in printData.quaran" :key="k">{{v}}</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">الدورات الحاصل عليا</td>
                    <td colspan="2">
                      <ul v-if="printData.courses.length">
                        <li v-for="(v,k) in printData.courses" :key="k">{{v}}</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">الخبرات</td>
                    <td colspan="2">
                      <ul v-if="printData.experience.length">
                        <li v-for="(v,k) in printData.experience" :key="k">{{v}}</li>
                      </ul>
                    </td>
                  </tr>

                </tbody>
              </table>
                </div>
              </div>
             

            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    Treeselect
  },
  data() {
    return {
      stages: [],
      groups: [],
      printData: {
        experience: [],
        courses: [],
        quaran: []
      },
      data: {
        data: {},
        searching:{
            id: '',
            name: '',
            email: '',
            mobile: '',
            whatsapp: '',
            isSupervisor: '',
            perPage: 10,
            sorting: 'desc',
            stage_id: '',
            group_id: ''
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       searchingMode: 0
    };
  },
  created(){
    this.flashAlert();
    this.getOptions('stage');
    this.getOptions('group');
    this.findResultsOfData();
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    printTable(){
      setTimeout(() => {
      this.print_element('print-table', 'المعلمين');
      
        
      }, 1000);
    },
    print(data){
      this.printData = data;
      setTimeout(() => {
      this.print_element('printMe', 'معلم');
      
        
      }, 1000);
    },
    onSearch(search, loading) {
      console.log(search);
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search(loading, w, vm){
      this.$baseApi.get('/teachers?pluck=1&search='+w).then((response)=>{
                  console.log(response.data.data);
                  loading(false);
            if(response.data.code == 200){
               this.options = response.data.data.teachers;

            }else{
                alert(response.data.error.error);
            }
        });
    },
      getOptions(type){
      this.$baseApi.get('/teachers?pluckType='+type).then((response)=>{
            if(response.data.code == 200){
              if(type == 'group'){
                this.groups = response.data.data.options;
              }else{
                this.stages = response.data.data.options;
              }

            }else{
                alert(response.data.error.error);
            }
        });
    },
    findResultsOfData(){
      this.$baseApi.get('/teachers?pluck=1&search=').then((response)=>{
            if(response.data.code == 200){
               this.options = response.data.data.teachers;

            }else{
                alert(response.data.error.error);
            }
        });
    },
    getGroups(val){
      this.$baseApi.get('/teachers?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        this.$baseApi.get('/teachers?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.teachers;
               this.data.data = response.data.data.teachers.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
